import React from 'react';

export default function ProgressBar({
  colour = '#002a4e',
  height = 40,
  label,
  value = 0
}) {
  const percentage = Math.max(0, Math.min(100, Number(value) || 0));

  return (
    <div
      className="relative w-full overflow-hidden bg-gray-200"
      style={{ height: `${height}px` }}
      role="progressbar"
      aria-label={label || `${percentage}% complete`}
      aria-valuemin="0"
      aria-valuemax="100"
      aria-valuenow={percentage}
    >
      <div
        aria-hidden="true"
        className="h-full transition-all"
        style={{
          width: `${percentage}%`,
          backgroundColor: colour,
          transitionDuration: '2000ms'
        }}
      />
      <span className="absolute inset-0 flex items-center justify-center text-sm font-semibold text-white">
        {percentage}%
      </span>
    </div>
  );
}
